import * as React from 'react'
import { useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { usePerformanceModuleContext } from 'modules/performance/hooks/usePerfomanceModuleContext'
import { useQuestionGroups } from 'modules/reviews/pages/performance/ReviewsReviewee/useQuestionGroups'

import SplitView from './SplitView'

const SplitViewReviewAnswerPage = () => {
  const { performanceFeatureAvailability } = usePerformanceModuleContext()
  const canSeeCompetencies = performanceFeatureAvailability.canSeeCompetencies
  const { id, user_id } = useParams()
  const reviewId = Number(id)
  const userId = Number(user_id)
  const { navigation } = useNavigation()
  const back = navigation.performance.reviews.id.reviews.targetReviewers.fullPath({
    id: reviewId,
    user_id: userId,
  })

  const { loading } = useQuestionGroups(reviewId, userId)

  if (loading) return null

  return (
    <SplitView
      formId={reviewId}
      userId={userId}
      back={back}
      canSeeCompetencies={canSeeCompetencies}
      useResponsivePage
    />
  )
}

export default SplitViewReviewAnswerPage
